'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _Body = require('./Body');

var _Body2 = _interopRequireDefault(_Body);

var _Container = require('./Container');

var _Container2 = _interopRequireDefault(_Container);

var _DataCell = require('./DataCell');

var _DataCell2 = _interopRequireDefault(_DataCell);

var _Head = require('./Head');

var _Head2 = _interopRequireDefault(_Head);

var _HeaderCell = require('./HeaderCell');

var _HeaderCell2 = _interopRequireDefault(_HeaderCell);

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  // BOUNTY: Significant karma points will be awarded to whoever figures out
  // how to have a fixed header that auto-sizes with a scrolling body without
  // using passed in hardcoded values like this.
  fillHeight: function fillHeight(_ref) {
    var headerHeight = _ref.headerHeight;
    return '\n    thead {\n      height: ' + (0, _decisivUiUtils.px2rem)(headerHeight) + ';\n    }\n\n    tbody {\n      height: calc(100% - ' + (0, _decisivUiUtils.px2rem)(headerHeight + 1) + ');\n    }\n  ';
  },

  scrollBodyY: function scrollBodyY(_ref2) {
    var headerHeight = _ref2.headerHeight;
    return '\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    overflow: -moz-scrollbars-none;\n    position: relative;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    tbody {\n      bottom: 0;\n      left: 0;\n      position: absolute;\n      right: 0;\n      top: ' + (0, _decisivUiUtils.px2rem)(headerHeight + 1) + ';\n    }\n  ';
  }
};

var styles = '\n  border-collapse: collapse;\n  height: 100%;\n  text-align: left;\n  width: 100%;\n\n  th, td {\n    padding: 0;\n  }\n';

var Table = (0, _decisivUiUtils.buildStyledComponent)('Table', _styledComponents2.default.table, styles, {
  modifierConfig: modifierConfig,
  propTypes: {
    headerHeight: _propTypes2.default.number
  },
  defaultProps: {
    headerHeight: 50
  }
});

Table.Body = _Body2.default;
Table.Container = _Container2.default;
Table.DataCell = _DataCell2.default;
Table.Head = _Head2.default;
Table.HeaderCell = _HeaderCell2.default;
Table.Row = _Row2.default;

exports.default = Table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Table/index.js
// module id = 1600
// module chunks = 2